import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import footerData from '../../../cms-data/footer.json';
import IndustryLinks from '../../../cms-data/industries/industries';

import styles from './Footer.module.scss';

let DataList = IndustryLinks.map(i => JSON.parse(i.replace(/\n/g, ' ')));

const Footer = ({ location: { pathname }, isSubdomain }) => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [mobileProductDropdownShow, setMobileProductDropdownShow] = useState(false);

  const {
    companyAddress: { address, footerLogo }, footerLinks,
    socialMediaLinks, copyrightInfo: { copyright }, msaPrivacySitemap,
  } = footerData;

  const createLink= (link) => {
    const absoluteDomain= 'https://razorthink.com'
    return isSubdomain ? `${absoluteDomain}${link}`: link
  }


  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.infoContainer}>
          <div className={styles.section1}>
            <div className={styles.logo}>
              <Link to='/'>
                <img alt='rzt-logo' src='logo' src={footerLogo.split('/public')[1]} />
              </Link>
            </div>
            <div className={styles.addressContainer}>
              {address}
            </div>
          </div>
        </div>

        {/*<div className={styles.industriesContainer}>*/}
        {/*  <div className={styles.desktopIndustries}>*/}
        {/*    <div className={styles.industriesHeading}>*/}
        {/*      Industries*/}
        {/*    </div>*/}
        {/*    <div className={styles.dropdownContent}>*/}
        {/*      {*/}
        {/*        DataList.map(item => {*/}
        {/*            let title = JSON.stringify(item.title);*/}
        {/*            let data = title.split(' ').join('-').toLowerCase();*/}
        {/*            let link = JSON.parse(data);*/}
        {/*            return (*/}
        {/*              isSubdomain ? <a href={createLink(`/industry-ai-solutions/${link}`)}>{item.title}</a> : <Link key={item} to={`/industry-ai-solutions/${link}`}>  {item.title}  </Link>)*/}
        {/*          },*/}
        {/*        )*/}
        {/*      }*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <div className={styles.mobileIndustriesDropdown}*/}
        {/*       onClick={() => setMobileProductDropdownShow(!mobileProductDropdownShow)}>*/}
        {/*    <button className={styles.dropButton}>Industries*/}
        {/*      <img className={styles.dropdownCaret} alt='caret' src='/img/homepage/dropdown.svg' />*/}
        {/*    </button>*/}
        {/*    <div className={`${mobileProductDropdownShow ? styles.showDropdown : null} ${styles.dropdownContent}`}>*/}
        {/*      {*/}
        {/*        DataList.map(item => {*/}
        {/*            let title = JSON.stringify(item.title);*/}
        {/*            let data = title.split(' ').join('-').toLowerCase();*/}
        {/*            let link = JSON.parse(data);*/}
        {/*            return (*/}
        {/*              isSubdomain ? <a href={createLink(`/industry-ai-solutions/${link}`)}>{item.title}</a> : <Link key={item} to={`/industry-ai-solutions/${link}`}>  {item.title}  </Link>)*/}
        {/*          },*/}
        {/*        )*/}
        {/*      }*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}

        <div className={styles.copyrightContainer}>
          <div className={styles.copyrightInfo}>
            <h6>
              {copyright}
            </h6>
          </div>
          <div className={styles.copyrightLinks}>
            {
              Object.keys(msaPrivacySitemap).map((item, index) => {
                return (
                  isSubdomain ? <a  href={createLink(msaPrivacySitemap[item].link)}><span>{msaPrivacySitemap[item].title}</span></a>
                  : <Link key={index}
                        to={msaPrivacySitemap[item].link}><span>{msaPrivacySitemap[item].title}</span></Link>
                );
              })
            }
          </div>
          <div className={styles.socialMediaLinks}>
            <ul>
              {
                socialMediaLinks.map((socialMediaLink, index) => {
                  const { socialMedia, link, icon } = socialMediaLink;
                  return (
                    <li key={index}><a target='_blank' href={link}><img alt={socialMedia}
                                                                        src={icon.split('/public')[1]} /></a></li>
                  );
                })
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Footer);
